import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Alert
} from '@mui/material';
import { INSTRUMENT_VALIDATION_ERROR_MESSAGES } from '../utils/instrumentValidation';

const InstrumentValidationErrorDialog = ({ open, onReturn, invalidTracks = [] }) => {
  return (
    <Dialog
      open={open}
      onClose={onReturn}
      maxWidth="md"
      fullWidth
      disableEscapeKeyDown
      PaperProps={{
        sx: {
          borderRadius: '12px',
          padding: '16px',
          minHeight: '300px'
        }
      }}
    >
      <DialogTitle sx={{ 
        textAlign: 'center', 
        fontSize: '24px', 
        fontWeight: 'bold',
        color: '#d32f2f',
        paddingBottom: '8px'
      }}>
        ⚠️ {INSTRUMENT_VALIDATION_ERROR_MESSAGES.TITLE}
      </DialogTitle>
      
      <DialogContent sx={{ paddingTop: '16px' }}>
        <Alert severity="error" sx={{ marginBottom: '24px' }}>
          <Typography variant="body1" sx={{ marginBottom: '12px', fontWeight: 500 }}>
            {INSTRUMENT_VALIDATION_ERROR_MESSAGES.ENGLISH}
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 500 }}>
            {INSTRUMENT_VALIDATION_ERROR_MESSAGES.CHINESE}
          </Typography>
        </Alert>
        
        {invalidTracks.length > 0 && (
          <Box sx={{ marginTop: '16px' }}>
            <Typography variant="h6" sx={{ marginBottom: '12px', fontWeight: 'bold' }}>
              Invalid Tracks Found (发现无效乐轨):
            </Typography>
            <Box sx={{ 
              backgroundColor: '#f5f5f5', 
              padding: '12px', 
              borderRadius: '8px',
              maxHeight: '200px',
              overflowY: 'auto'
            }}>
              {invalidTracks.map((track, index) => (
                <Box key={index} sx={{ marginBottom: '8px', padding: '8px', backgroundColor: 'white', borderRadius: '4px' }}>
                  <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                    Track ID: {track.trackId}
                  </Typography>
                  <Typography variant="body2">
                    Track Name: "{track.trackName}"
                  </Typography>
                  {track.instrument && (
                    <Typography variant="body2" sx={{ color: '#666' }}>
                      Instrument Path: {track.instrument}
                    </Typography>
                  )}
                </Box>
              ))}
            </Box>
          </Box>
        )}
        
        <Box sx={{ marginTop: '24px', padding: '16px', backgroundColor: '#fff3cd', borderRadius: '8px', border: '1px solid #ffeaa7' }}>
          <Typography variant="body2" sx={{ fontStyle: 'italic', textAlign: 'center' }}>
            <strong>Note:</strong> This file cannot be opened for annotation until the instrument validation issues are resolved by the admin team.
            <br />
            <strong>注意：</strong> 在管理员团队解决乐器验证问题之前，此文件无法打开进行标注。
          </Typography>
        </Box>
      </DialogContent>
      
      <DialogActions sx={{ justifyContent: 'center', paddingTop: '24px' }}>
        <Button
          onClick={onReturn}
          variant="contained"
          size="large"
          sx={{
            backgroundColor: '#1976d2',
            color: 'white',
            fontWeight: 'bold',
            fontSize: '16px',
            padding: '12px 32px',
            borderRadius: '8px',
            '&:hover': {
              backgroundColor: '#1565c0'
            }
          }}
        >
          {INSTRUMENT_VALIDATION_ERROR_MESSAGES.RETURN_BUTTON}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InstrumentValidationErrorDialog;
